import _noop from 'lodash/noop';
import 'lodash/has';
import 'prop-types';
import '@dbh/with-conforms-to-for-production-www';

/**
 * Given a React custom `prop-types` function, returns a React custom `prop-types`
 * function that has automatic support and error message for `.isRequired`.
 * @return {Function} Custom React `prop-types` validator.
 * @example
 * ```js
 * SomeComponent.propTypes = {
 *   someProp: createCustomReactPropType(someValidatorFn),
 *   someOtherProp: createCustomReactPropType(someValidatorFn).isRequired,
 * };
 * ```
 * @see {@link https://github.com/facebook/prop-types}
 * @see {@link https://lodash.com/docs/4.17.11#has}
 */const createCustomReactPropType=()=>_noop;

export { createCustomReactPropType as default };
